export default __webpack_public_path__ + "static/cafe_36015-dc9ef440168673a94e7f7caa976f1b63.png";